import type { HeaderVersion } from '../../core/types';

const storageKey = 'headerVersion';

export const getHeaderVersion = () => {
    return localStorage.getItem(storageKey);
};

export const setHeaderVersion = (headerVersion: HeaderVersion) => {
    localStorage.setItem(storageKey, headerVersion);
};

export const isOldHeader = () => {
    return !getHeaderVersion() || getHeaderVersion() === 'v0';
};

export const isV1Header = () => {
    return getHeaderVersion() === 'v1';
};

export const isV2Header = () => {
    return getHeaderVersion() === 'v2';
};
